import { Route, Routes } from 'react-router-dom'
import { FtxPage } from './pages/FtxPage'
import { MiningPage } from './pages/MiningPage';
import { PledgeHistorPage } from './pages/PledgeHistoryPage';
import { PurchasePage } from './pages/PurchasePage';
import { NftPage } from './pages/NftPage';
import { NftPreSalePage } from './pages/NftPreSalePage';
import { AiNftMintPage } from './pages/AiNftMintPage';
import { NftExplorePage } from './pages/NftExplorePage';
import { InfoPage } from './pages/InfoPage';
import { WalletPage } from './pages/WalletPage';
import { FtxCompletedOrderPage } from './pages/FtxCompletedOrderPage';
import { NftDetailPage } from './pages/NFT/NftDetailPage/index';
import { AppLayout } from './layouts/AppLayout';
import { WebLayout } from './layouts/WebLayout';
import { StoreLayout } from './layouts/StoreLayout';
import { NftHomePage } from './pages/NFT/NftHomePage/index';
import { LoginPage } from './pages/LoginPage';
import { SignUpPage } from './pages/SignUpPage';
import { FavoriteCryptoPage } from './pages/AI/FavoriteCryptoPage';
import { NftMintPage } from './pages/NFT/NftMintPage';
import { NftMyAssetPage } from './pages/NFT/NtfMyAssetPage';
import { NftMyFavoritePage } from './pages/NFT/NftMyFavoritePage';
import { NftOrderHistoryPage } from './pages/NFT/NftOrderHistoryPage';
import { NftProfilePage } from './pages/NFT/NftProfilePage';
import { NftWalletPage } from './pages/NFT/NftWalletPage';
import { NftTop100Page } from './pages/NFT/NftTop100Page';
import { NftSearchPage } from './pages/NFT/NftSearchPage';
import { NftCreatorPage } from './pages/NFT/NftCreatorPage';
import { BusinessTodayRedirectPage } from './pages/NFT/PartnerRedirectPage/BusinessTodayRedirectPage';
import { PartnerPage } from './pages/PartnerPage';
import { StoreWalletPage } from './pages/store/WalletPage';
import { UserProfilePage } from './pages/store/UserProfilePage';
import { ReferralPage } from './pages/store/ReferralPage';
import { RegistrationPage } from './pages/store/RegistrationPage';
import { StoreLoginPage } from './pages/store/LoginPage';
import { TeamPage } from './pages/store/TeamPage';
import { ProductManagementPage } from './pages/store/ProductManagementPage';
import { CreateProductPage } from './pages/store/CreateProductPage';
import { HomePage } from './pages/store/HomePage';
import { ProductDetailPage } from './pages/store/DetailPage';
import { RestoreStoragePage } from './pages/RestoreStoragePage';

export const RouteTable = () => {
  return (
    <Routes>
      <Route path='/app' element={<AppLayout />}>
        <Route path='ftx' element={<FtxPage />} />
        <Route path='ftx/order/completed/:orderId' element={<FtxCompletedOrderPage />} />
        <Route path='mining' element={<MiningPage />} />
        <Route path='pledge-history' element={<PledgeHistorPage />} />
        <Route path='purchase/:token' element={<PurchasePage />} />
        <Route path='nft' element={<NftPage />} />
        <Route path='nft-pre-sale' element={<NftPreSalePage />} />
        <Route path='nft-mint' element={<AiNftMintPage />} />
        <Route path='nft-explore' element={<NftExplorePage />} />
        <Route path='info' element={<InfoPage />} />
        <Route path='wallet' element={<WalletPage />} />
        <Route path='favorite/crypto' element={<FavoriteCryptoPage />} />
      </Route>
      <Route path='/web' element={<WebLayout />}>
        <Route path='home' element={<NftHomePage />} />
        <Route path='top100' element={<NftTop100Page />} />
        <Route path='search' element={<NftSearchPage />} />
        <Route path='login/:projectCode' element={<LoginPage />} />
        <Route path='login/:projectCode/:redirectUrl' element={<LoginPage />} />
        <Route path='signup/:projectCode' element={<SignUpPage />} />
        <Route path='asset/detail/:nftId' element={<NftDetailPage />} />
        <Route path='asset/detail/:nftId/:tokenId' element={<NftDetailPage />} />
        <Route path='asset/my' element={<NftMyAssetPage />} />
        <Route path='asset/my/favorite' element={<NftMyFavoritePage />} />
        <Route path='order/history' element={<NftOrderHistoryPage />} />
        <Route path='profile' element={<NftProfilePage />} />
        <Route path='wallet' element={<NftWalletPage />} />
        <Route path='mint' element={<NftMintPage />} />
        <Route path='creator/:memberNo' element={<NftCreatorPage />} />
        <Route path='partner/businesstoday/redirect' element={<BusinessTodayRedirectPage />} />
        <Route path='partner' element={<PartnerPage />} />
        <Route path='restore/storage' element={<RestoreStoragePage />} />
      </Route>
      <Route path='/store/:projectCode' element={<StoreLayout />}>
        <Route path='login' element={<StoreLoginPage />} />
        <Route path='home' element={<HomePage />} />
        <Route path='product/detail/:idProducts' element={<ProductDetailPage />} />
        <Route path='profile' element={<UserProfilePage />} />
        <Route path='wallet' element={<StoreWalletPage />} />
        <Route path='referral' element={<ReferralPage />} />
        <Route path='registration' element={<RegistrationPage />} />
        <Route path='team' element={<TeamPage />} />
        <Route path='product-management' element={<ProductManagementPage />} />
        <Route path='product-create' element={<CreateProductPage />} />
      </Route>
    </Routes>
  );
};